/**
 * A sale on the pass: a share off both terms until a fixed moment.
 *
 * `shared/plans.ts` keeps the list price — the Stripe product price, the
 * lookup key and every page that quotes "129 zł" — and the sale is applied on
 * top of it, in Stripe as a coupon on the checkout session. The order records
 * what was charged, so the list price never rewrites anybody's history. Oral
 * packs are not part of it.
 *
 * Ending a sale is deleting the entry here (or letting `endsAt` pass); nothing
 * has to be undone in Stripe, because the price underneath never moved.
 */
import { isPack, type Product } from "./plans.ts";

export interface Promo {
  /** Stripe coupon id, made by `scripts/stripe-products.ts`. */
  couponId: string;
  percent: number;
  /** Epoch ms; the sale is on while `now < endsAt`. */
  endsAt: number;
}

/** 20% off both passes until the end of Sat 24 Oct 2026, Warsaw time (UTC+2). */
export const PROMO: Promo | null = {
  couponId: "pass-20-2026-10",
  percent: 20,
  endsAt: Date.parse("2026-10-24T21:59:59Z"),
};

export const activePromo = (ts: number = Date.now()): Promo | null =>
  PROMO && ts < PROMO.endsAt ? PROMO : null;

/** What a product costs now, in grosze: the sale price while one is on and applies. */
export function chargeMinor(p: Product, ts: number = Date.now()): number {
  const promo = activePromo(ts);
  if (!promo || isPack(p)) return p.amountMinor;
  return Math.round((p.amountMinor * (100 - promo.percent)) / 100);
}
